customElements.define('component-card-text', class CardText extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const template = document.getElementById('js-card-text-template');
    this.appendChild(template.content.cloneNode(true));

    // Properties
    this.link = this.getAttribute('link') || '#';
    this.heading = this.getAttribute('heading') || '';
    this.subHeading = this.getAttribute('sub-heading') || '';

    // DOM elements
    this.cardTitle = this.querySelector('.card-text-title');
    this.cardButton = this.querySelector('.card-text-button');

    // Init
    this.cardTitle.innerHTML = `<p>${this.heading}</p>`;
    this.cardButton.innerHTML = `<p>${this.subHeading}</p>`;
    // In case the URL doesn't include de domain
    if (!(/^https?:\/\//ig).test(this.link)) {
      this.baseUrlSplit = window.location.host.split('.')
      this.baseUrlSplit.shift();
      this.baseUrl = this.baseUrlSplit.join('.');
      this.link = `https://www.${this.baseUrl}${this.link}`;
    }
    this.cardButton.href = this.link;

    // Event handlers
    this.cardButton.addEventListener("click", () => {
      this.trackGTM(this.link, this.subHeading);
    });
  }

  trackGTM(link, subHeading) {
    window.sendGTMData && window.sendGTMData({
      event: 'menu-card-text-click',
      source: 'menu-card-text',
      nav_bar_section_url: link,
      nav_bar_section_text: subHeading
    });
  }
});
